import Vue from 'vue'
import Vuex from 'vuex'
import githubStore from '@/store/modules/github'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    githubStore
  }
})
